/* ==========================================================================
   Voltaire Amsterdam — globale Theme-Logik
   - Header (Menü, Suche)
   - Warenkorb-Drawer (Ajax Cart API)
   - Bundle-Logik: Rabattcode nach BH-Anzahl + Gratisartikel
   ========================================================================== */
(function () {
  'use strict';

  var V = window.Voltaire || {};
  var cfg = V.bundle || { enabled: false, braIds: [], gifts: [] };
  var routes = V.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' };
  var GIFT_PROP = '_voltaire_gift';

  /* ---------- Helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: V.currency || 'EUR' }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }
  function imgUrl(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }
  function colorName(value) {
    if (!value) return '';
    var map = V.colorNames || {};
    var hit = map[String(value).trim().toLowerCase()];
    return hit ? hit.name : value;
  }
  function colorSwatch(value) {
    var map = V.colorNames || {};
    var hit = map[String(value || '').trim().toLowerCase()];
    return hit ? hit.swatch : 'oklch(0.8 0.02 60)';
  }
  function storage(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) { /* privater Modus o. Ä. */ }
    return null;
  }
  function icon(name) {
    var paths = {
      x: '<path d="M18 6 6 18M6 6l12 12"/>',
      minus: '<path d="M5 12h14"/>',
      plus: '<path d="M5 12h14M12 5v14"/>',
      check: '<path d="M20 6 9 17l-5-5"/>',
      truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
      gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/>',
      shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>'
    };
    return '<svg class="icon icon--sm" viewBox="0 0 24 24" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }

  /* ---------- Toast ---------- */
  function toast(message, detail, type) {
    var region = $('[data-toast-region]');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.innerHTML = esc(message) + (detail ? '<small>' + esc(detail) + '</small>' : '');
    region.appendChild(el);
    setTimeout(function () { el.remove(); }, 3800);
  }

  /* ---------- Cart API ---------- */
  function request(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body !== undefined) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Fehler');
          err.data = data; throw err;
        }
        return data;
      });
    });
  }
  var Cart = {
    state: null,
    get: function () { return request(routes.cart + '.js').then(function (c) { Cart.state = c; return c; }); },
    add: function (items) { return request(routes.cartAdd + '.js', { items: items }); },
    change: function (key, quantity) { return request(routes.cartChange + '.js', { id: key, quantity: quantity }).then(function (c) { Cart.state = c; return c; }); },
    update: function (body) { return request(routes.cartUpdate + '.js', body).then(function (c) { Cart.state = c; return c; }); }
  };

  /* ---------- Bundle-Logik ---------- */
  var braIdSet = {};
  (cfg.braIds || []).forEach(function (id) { braIdSet[String(id)] = true; });

  function isGift(item) { return item.properties && item.properties[GIFT_PROP]; }
  function isBra(item) { return !isGift(item) && braIdSet[String(item.product_id)] === true; }
  function braCount(cart) {
    return (cart.items || []).reduce(function (sum, item) { return sum + (isBra(item) ? item.quantity : 0); }, 0);
  }
  function codeFor(count) {
    if (!cfg.enabled) return '';
    if (count >= 3 && cfg.code3) return cfg.code3;
    if (count === 2 && cfg.code2) return cfg.code2;
    return '';
  }
  function rateFor(count) {
    if (count >= 3) return cfg.rate3 || 0;
    if (count === 2) return cfg.rate2 || 0;
    return 0;
  }
  function giftsFor(count) {
    if (!cfg.enabled) return [];
    return (cfg.gifts || []).filter(function (g) { return g && count >= g.min; });
  }
  function giftChoice(gift) {
    var saved = storage('voltaire:gift:' + gift.handle);
    var variants = gift.variants || [];
    var hit = variants.filter(function (v) { return String(v.id) === String(saved) && v.available; })[0];
    return hit || variants.filter(function (v) { return v.available; })[0] || null;
  }
  function setGiftChoice(handle, variantId) { storage('voltaire:gift:' + handle, String(variantId)); }

  var syncing = false;
  /**
   * Bringt den Warenkorb in Einklang mit dem Bundle-Angebot:
   * Gratisartikel hinzufügen/entfernen und den passenden Rabattcode setzen.
   * Shopify selbst berechnet Rabatt und Gratispreis (automatische Rabatte / Codes).
   */
  function syncBundle(cart) {
    if (!cfg.enabled || syncing) return Promise.resolve(cart);
    syncing = true;
    var count = braCount(cart);
    var needed = giftsFor(count);
    var neededIds = {};
    needed.forEach(function (g) { neededIds[String(g.id)] = g; });

    var chain = Promise.resolve(cart);
    var giftLines = (cart.items || []).filter(isGift);

    // 1. Überflüssige Gratisartikel entfernen bzw. auf Menge 1 setzen
    giftLines.forEach(function (line) {
      var gift = neededIds[String(line.product_id)];
      var seen = giftLines.filter(function (l) { return String(l.product_id) === String(line.product_id); })[0];
      if (!gift || seen.key !== line.key) {
        chain = chain.then(function () { return Cart.change(line.key, 0); });
      } else if (line.quantity !== 1) {
        chain = chain.then(function () { return Cart.change(line.key, 1); });
      }
    });

    // 2. Fehlende Gratisartikel hinzufügen
    var toAdd = needed.filter(function (g) {
      return !giftLines.some(function (l) { return String(l.product_id) === String(g.id); });
    }).map(function (g) {
      var choice = giftChoice(g);
      if (!choice) return null;
      var props = {}; props[GIFT_PROP] = 'Gratis';
      return { id: choice.id, quantity: 1, properties: props };
    }).filter(Boolean);
    if (toAdd.length) chain = chain.then(function () { return Cart.add(toAdd); });

    // 3. Rabattcode setzen (nur wenn im Theme eingetragen). Andere Codes der Kundin bleiben erhalten.
    if (cfg.code2 || cfg.code3) {
      var ours = [cfg.code2, cfg.code3].filter(Boolean).map(function (c) { return c.toUpperCase(); });
      var current = (cart.discount_codes || []).map(function (d) { return String(d.code || ''); }).filter(Boolean);
      var others = current.filter(function (c) { return ours.indexOf(c.toUpperCase()) === -1; });
      var wanted = codeFor(count);
      var next = others.concat(wanted ? [wanted] : []);
      var same = next.length === current.length && next.every(function (c) {
        return current.some(function (x) { return x.toUpperCase() === c.toUpperCase(); });
      });
      if (!same) {
        chain = chain.then(function () { return Cart.update({ discount: next.join(',') }); }).catch(function () { return null; });
      }
    }

    return chain.then(function () { return Cart.get(); }).then(function (fresh) {
      syncing = false;
      return fresh;
    }, function (err) {
      syncing = false;
      return Cart.get();
    });
  }

  /* ---------- Drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    document.dispatchEvent(new CustomEvent('voltaire:drawer', { detail: { open: true } }));
    var close = $('[data-cart-close]', drawer);
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    document.dispatchEvent(new CustomEvent('voltaire:drawer', { detail: { open: false } }));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(cart) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function lineMeta(item) {
    var parts = [];
    (item.options_with_values || []).forEach(function (o) {
      if (!o.value || o.value === 'Default Title') return;
      var n = String(o.name || '').toLowerCase();
      if (/(farbe|color|colour|kleur)/.test(n)) parts.push(colorName(o.value));
      else if (/(größe|groesse|size|maat)/.test(n)) parts.push('Größe ' + o.value);
      else parts.push(o.value);
    });
    return parts.join(' · ');
  }

  function milestoneHtml(count) {
    if (!cfg.enabled || count === 0) return '';
    var g2 = (cfg.gifts || []).filter(function (g) { return g && g.min <= 2; })[0];
    var g3 = (cfg.gifts || []).filter(function (g) { return g && g.min === 3; })[0];
    var p2 = Math.round((cfg.rate2 || 0) * 100);
    var p3 = Math.round((cfg.rate3 || 0) * 100);
    var text;
    if (count === 1) {
      text = 'Fügen Sie einen 2. BH hinzu: <strong>' + (p2 ? p2 + ' % Rabatt' : 'Bundle-Vorteil') + '</strong>' + (g2 ? ' + ' + esc(g2.label) : '') + '.';
    } else if (count === 2) {
      text = 'Noch 1 BH bis <strong>' + (p3 ? p3 + ' % Rabatt' : 'zum besten Angebot') + '</strong>' + (g3 ? ' + ' + esc(g3.label) : '') + '.';
    } else {
      text = '<strong>Bestes Angebot aktiv' + (p3 ? ': ' + p3 + ' % Rabatt' : '') + '</strong>' + (g3 || g2 ? ' + Geschenke' : '') + '.';
    }
    var pct = Math.min(count, 3) / 3 * 100;
    return '<div class="milestone">' +
      '<p class="milestone__text">' + text + '</p>' +
      '<div class="milestone__bar"><span style="width:' + pct + '%"></span></div>' +
      '<div class="milestone__steps">' +
        '<span class="' + (count >= 1 ? 'is-reached' : '') + '">1 BH</span>' +
        '<span class="' + (count >= 2 ? 'is-reached' : '') + '">2 BHs' + (p2 ? ' · −' + p2 + ' %' : '') + '</span>' +
        '<span class="' + (count >= 3 ? 'is-reached' : '') + '">3 BHs' + (p3 ? ' · −' + p3 + ' %' : '') + '</span>' +
      '</div></div>';
  }

  function giftPickerHtml(cart) {
    var lines = (cart.items || []).filter(isGift);
    if (!lines.length) return '';
    var html = '';
    lines.forEach(function (line) {
      var gift = (cfg.gifts || []).filter(function (g) { return g && String(g.id) === String(line.product_id); })[0];
      if (!gift) return;
      var seenColors = {};
      var options = (gift.variants || []).filter(function (v) {
        if (!v.available || seenColors[v.color]) return false;
        seenColors[v.color] = true; return true;
      });
      var lineColor = ((gift.variants || []).filter(function (v) { return String(v.id) === String(line.variant_id); })[0] || {}).color;
      if (options.length < 2) return;
      html += '<div class="gift-picker__group"><p class="gift-picker__title">' + icon('gift') + esc(gift.label) + ': Farbe wählen</p><div class="gift-picker__choices" role="radiogroup" aria-label="Farbe für ' + esc(gift.title) + '">';
      options.forEach(function (v) {
        var checked = v.color === lineColor;
        html += '<button type="button" class="gift-choice" role="radio" aria-checked="' + checked + '" data-gift-swap="' + esc(line.key) + '" data-gift-handle="' + esc(gift.handle) + '" data-variant="' + v.id + '">' +
          '<span class="gift-choice__dot" style="background:' + esc(v.swatch) + '"></span>' + esc(v.color) + '</button>';
      });
      html += '</div></div>';
    });
    return html ? '<div class="gift-picker">' + html + '</div>' : '';
  }

  function renderDrawer(cart) {
    updateCount(cart);
    document.dispatchEvent(new CustomEvent('voltaire:cart', { detail: { cart: cart, braCount: braCount(cart) } }));
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    var countEl = $('[data-cart-title-count]', drawer);
    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>Ihr Warenkorb ist noch leer.</p><a class="btn btn--dark" href="' + esc(drawer.getAttribute('data-shop-url') || routes.root) + '">BHs entdecken</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    var count = braCount(cart);
    var max = cfg.maxBras || 0;
    var html = milestoneHtml(count) + '<ul class="line-items">';
    cart.items.forEach(function (item) {
      var gift = isGift(item);
      var bra = isBra(item);
      var plusDisabled = gift || (bra && max && count >= max);
      var original = item.original_line_price;
      var final = item.final_line_price;
      html += '<li class="line-item">' +
        (item.image ? '<img class="line-item__img" src="' + esc(imgUrl(item.image, 160)) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '<span class="line-item__img"></span>') +
        '<div class="line-item__info">' +
          '<div class="line-item__top"><div><a class="line-item__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            (lineMeta(item) ? '<p class="line-item__meta">' + esc(lineMeta(item)) + '</p>' : '') +
            (gift ? '<span class="line-item__gift">Geschenk</span>' : '') +
          '</div>' +
          (gift ? '' : '<button type="button" class="line-item__remove" aria-label="' + esc(item.product_title) + ' entfernen" data-line-remove="' + esc(item.key) + '">' + icon('x') + '</button>') +
          '</div>' +
          '<div class="line-item__bottom">' +
            (gift ? '<span class="max-note">Menge 1</span>' :
              '<div class="qty"><button type="button" aria-label="Menge verringern" data-line-qty="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '">' + icon('minus') + '</button>' +
              '<span aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" aria-label="Menge erhöhen" data-line-qty="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '"' + (plusDisabled ? ' disabled title="' + esc(V.strings && V.strings.maxBras) + '"' : '') + '>' + icon('plus') + '</button></div>') +
            '<span class="line-item__price">' + (final === 0 ? 'Gratis' : money(final)) + (original > final ? '<s>' + money(original) + '</s>' : '') + '</span>' +
          '</div>' +
        '</div></li>';
    });
    html += '</ul>';
    if (max && count >= max) html += '<p class="max-note">' + esc(V.strings && V.strings.maxBras) + '.</p>';
    html += giftPickerHtml(cart);
    body.innerHTML = html;

    // Summen
    var originalTotal = cart.original_total_price != null ? cart.original_total_price : cart.items.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var giftValue = cart.items.filter(isGift).reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var discount = Math.max(0, originalTotal - cart.total_price - giftValue);
    var codes = (cart.cart_level_discount_applications || []).concat([]).map(function (d) { return d.title; });
    cart.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && codes.indexOf(a.discount_application.title) === -1 && !isGift(i)) codes.push(a.discount_application.title); }); });
    var expectedCode = codeFor(count);
    var totalsHtml = '<dl class="totals">' +
      '<div class="totals__row"><dt>Zwischensumme</dt><dd>' + money(originalTotal - giftValue) + '</dd></div>' +
      (discount > 0 ? '<div class="totals__row totals__row--save"><dt>Rabatt' + (codes.length ? ' (' + esc(codes.join(', ')) + ')' : '') + '</dt><dd>−' + money(discount) + '</dd></div>' :
        (expectedCode ? '<div class="totals__row totals__row--muted"><dt>Bundle-Rabatt (' + esc(expectedCode) + ')</dt><dd>wird im Checkout abgezogen</dd></div>' : '')) +
      (giftValue > 0 ? '<div class="totals__row totals__row--save"><dt style="display:flex;align-items:center;gap:.375rem">' + icon('gift') + ' Geschenke</dt><dd>Gratis</dd></div>' : '') +
      '<div class="totals__row"><dt>Versand</dt><dd>' + esc(drawer.getAttribute('data-shipping-label') || 'Wird im Checkout berechnet') + '</dd></div>' +
      '<div class="totals__row totals__row--total"><dt>Gesamt</dt><dd>' + money(cart.total_price) + '</dd></div>' +
      '</dl>';
    $('[data-cart-totals]', foot).innerHTML = totalsHtml;
    var checkout = $('[data-cart-checkout]', foot);
    if (checkout) checkout.setAttribute('href', '/checkout' + (expectedCode ? '?discount=' + encodeURIComponent(expectedCode) : ''));
  }

  function refresh(opts) {
    opts = opts || {};
    if (drawer) drawer.classList.add('is-loading');
    var p = opts.cart ? Promise.resolve(opts.cart) : Cart.get();
    return p.then(function (cart) { return opts.sync === false ? cart : syncBundle(cart); })
      .then(function (cart) { renderDrawer(cart); return cart; })
      .catch(function () { toast('Der Warenkorb konnte nicht geladen werden.', null, 'error'); })
      .then(function (cart) { if (drawer) drawer.classList.remove('is-loading'); return cart; });
  }

  /**
   * Öffentliche Funktion für Produktseiten: mehrere Zeilen hinzufügen,
   * Bundle synchronisieren und den Drawer öffnen.
   */
  function addItems(items, options) {
    options = options || {};
    var check = Promise.resolve();
    if (cfg.enabled && cfg.maxBras) {
      check = Cart.get().then(function (cart) {
        var adding = items.reduce(function (s, i) { return s + (braIdSet[String(i.productId)] ? i.quantity : 0); }, 0);
        if (adding && braCount(cart) + adding > cfg.maxBras) {
          var err = new Error('max'); err.code = 'max'; throw err;
        }
      });
    }
    return check.then(function () {
      return Cart.add(items.map(function (i) {
        var line = { id: i.id, quantity: i.quantity || 1 };
        if (i.properties) line.properties = i.properties;
        return line;
      }));
    }).then(function () { return refresh(); }).then(function (cart) {
      if (options.open !== false) openDrawer();
      return cart;
    }).catch(function (err) {
      if (err && err.code === 'max') {
        toast(V.strings.maxBras + '.', 'Bitte passen Sie zuerst Ihren Warenkorb an.', 'error');
        openDrawer();
      } else {
        toast((err && err.message) || V.strings.addError, null, 'error');
      }
      throw err;
    });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target;
    var open = t.closest('[data-cart-open]');
    if (open && drawer && !document.body.classList.contains('template-cart')) {
      event.preventDefault(); refresh(); openDrawer(); return;
    }
    if (t.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }

    var qty = t.closest('[data-line-qty]');
    if (qty) {
      event.preventDefault();
      var q = Math.max(0, parseInt(qty.getAttribute('data-qty'), 10) || 0);
      drawer && drawer.classList.add('is-loading');
      Cart.change(qty.getAttribute('data-line-qty'), q).then(function (cart) { return refresh({ cart: cart }); })
        .catch(function (e) { toast(e.message, null, 'error'); refresh(); });
      return;
    }
    var rm = t.closest('[data-line-remove]');
    if (rm) {
      event.preventDefault();
      drawer && drawer.classList.add('is-loading');
      Cart.change(rm.getAttribute('data-line-remove'), 0).then(function (cart) { return refresh({ cart: cart }); });
      return;
    }
    var swap = t.closest('[data-gift-swap]');
    if (swap) {
      event.preventDefault();
      if (swap.getAttribute('aria-checked') === 'true') return;
      setGiftChoice(swap.getAttribute('data-gift-handle'), swap.getAttribute('data-variant'));
      drawer && drawer.classList.add('is-loading');
      Cart.change(swap.getAttribute('data-gift-swap'), 0).then(function (cart) { return refresh({ cart: cart }); });
      return;
    }

    // Header: Menü / Suche
    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = $('[data-mobile-nav]');
      var isOpen = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!isOpen));
      menuBtn.setAttribute('aria-label', isOpen ? 'Menü öffnen' : 'Menü schließen');
      $('[data-menu-icon-open]', menuBtn).hidden = !isOpen;
      $('[data-menu-icon-close]', menuBtn).hidden = isOpen;
      if (nav) nav.hidden = isOpen;
      return;
    }
    var searchBtn = t.closest('[data-search-toggle]');
    if (searchBtn) {
      var panel = $('[data-search-panel]');
      var expanded = searchBtn.getAttribute('aria-expanded') === 'true';
      searchBtn.setAttribute('aria-expanded', String(!expanded));
      if (panel) {
        panel.hidden = expanded;
        if (!expanded) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
      }
      return;
    }
    if (t.closest('[data-cookie-settings]')) {
      event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Einfache Produktformulare (z. B. Accessoires): per Ajax hinzufügen
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-add]');
    if (!form) return;
    event.preventDefault();
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    addItems([{ id: Number(id), quantity: Number(data.get('quantity') || 1), productId: form.getAttribute('data-product-id') }])
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  });

  // Cookie-Link nur zeigen, wenn Shopifys Cookie-Banner aktiv ist
  function showCookieLink() {
    if (window.privacyBanner) $all('[data-cookie-settings]').forEach(function (b) { b.hidden = false; });
  }
  document.addEventListener('DOMContentLoaded', function () {
    showCookieLink(); setTimeout(showCookieLink, 2000);
    // Beim Laden einmal synchronisieren (z. B. nach Rückkehr aus dem Checkout)
    if (cfg.enabled && V.cartCount > 0) refresh();
    else if (V.cartCount === 0 && drawer) renderDrawer({ items: [], item_count: 0, total_price: 0 });
  });

  /* ---------- Export ---------- */
  window.VoltaireCart = {
    addItems: addItems,
    open: openDrawer,
    close: closeDrawer,
    refresh: refresh,
    get: Cart.get,
    braCount: braCount,
    giftsFor: giftsFor,
    giftChoice: giftChoice,
    setGiftChoice: setGiftChoice,
    isBra: function (productId) { return braIdSet[String(productId)] === true; },
    money: money,
    colorName: colorName,
    colorSwatch: colorSwatch,
    imgUrl: imgUrl,
    toast: toast,
    esc: esc,
    config: cfg
  };
})();
